import React, { FC, HTMLAttributes } from 'react'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'

interface Props extends HTMLAttributes<HTMLElement> {
  showBusy: boolean
  width?: number
}

export const BusyIndicator: FC<Props> = ({ showBusy, width, ...props }) => {
  return showBusy ? (
    <img
      {...props}
      className="mx-auto animate-spin"
      src={getCloudinaryImageUrl({ path: 'v1648441174/angel-studios/market/arrows-spin' })}
      width={width ? width : 30}
      height={width ? width : 30}
    />
  ) : null
}
